var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStroy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 44.0043V40.3372L24.8745 29.9473L49.891 40.3372V44.0043L24.8745 38.5037L0 44.0043Z",
    fill: "#E41170"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.078125 50.0001V47.3L24.8747 42.7998L50.0007 47.3V50.0001H24.8747H0.078125Z",
    fill: "#E41170"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 37.2819V31.1701L24.9455 16.502L49.891 31.1701V36.6707L24.9455 25.6696L0 37.2819Z",
    fill: "#E41170"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 27.5029V23.8358L24.9455 0L49.891 25.6693V29.3364L24.9455 9.7788L0 27.5029Z",
    fill: "#E41170"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStroy);
export default __webpack_public_path__ + "static/media/stroy.ccc7750870957f6d2aa4f6122d02ec0f.svg";
export { ForwardRef as ReactComponent };